import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import { useAdminAuth } from '../../context/AdminAuthContext';

export default function AdminLoginPage() {
  const [mobile, setMobile]   = useState('');
  const [loading, setLoading] = useState(false);
  const { login }             = useAdminAuth();
  const navigate              = useNavigate();

  const handleLogin = async () => {
    if (!/^[6-9]\d{9}$/.test(mobile))
      return toast.error('Enter valid 10-digit mobile number');

    setLoading(true);
    try {
      // Send OTP → get back auto-fill OTP if DEFAULT_OTP is set
      const { data: otpData } = await api.post('/auth/send-otp', { mobile });
      const otpToUse = otpData?.otp || '111111'; // auto-fill from backend, fallback to default

      // Verify immediately
      const { data } = await api.post('/auth/verify-otp', { mobile, otp: otpToUse });

      if (!['admin', 'superadmin'].includes(data.user?.role)) {
        toast.error('Access denied. Admin accounts only.');
        return;
      }

      login(data.user, data.accessToken);
      toast.success(`Welcome, ${data.user.name || 'Admin'}!`);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo__badge"></div>
          <div className="auth-logo__name">Zeva2 Admin</div>
          <div className="auth-logo__sub">Management Portal — Authorized Access Only</div>
        </div>
        <div className="form-group">
          <label className="label">Admin Mobile Number</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ padding: '9px 12px', background: '#f1f3f5', border: '1px solid #dee2e6', borderRadius: 8, color: '#495057', fontSize: 13, whiteSpace: 'nowrap' }}>+91</div>
            <input
              className="input"
              type="tel"
              inputMode="numeric"
              maxLength={10}
              placeholder="Admin mobile number"
              value={mobile}
              onChange={e => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              autoFocus
            />
          </div>
        </div>
        <div className="alert alert--primary" style={{ fontSize: 12 }}>
          🔒 Authorized admins only. Unauthorized access prohibited.
        </div>
        <button
          className="btn btn--primary btn--full btn--lg"
          onClick={handleLogin}
          disabled={loading || mobile.length !== 10}>
          {loading
            ? <><span className="spinner spinner--sm spinner--white" /> Authenticating...</>
            : 'Login to Admin Panel →'}
        </button>
      </div>
    </div>
  );
}